import { render, staticRenderFns } from "./AddNewPlayer.vue?vue&type=template&id=6eef0f50"
import script from "./AddNewPlayer.vue?vue&type=script&lang=js"
export * from "./AddNewPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports